import axios from 'axios'

interface ApplicationSummary {
    id: string
    projectName: string
    company: {
        name?: string
        mcNumber?: string
        dotNumber?: string
    } | null
    status: string
}

interface OrganizationSummary {
    id: string
    name?: string
    ownerId: string
    applicationIds: string[]
    createdAt: string
    updatedAt: string
}

export interface MigrationPreview {
    sourceOrganization: OrganizationSummary
    applications: ApplicationSummary[]
}

export interface MigrationResult {
    movedApplicationIds: string[]
}

export const migrationApi = {
    async preview(email: string): Promise<MigrationPreview> {
        const res = await axios.get<{ success: boolean; data: MigrationPreview }>(`/gluon/organizations/migrate/preview?email=${encodeURIComponent(email)}`)
        return res.data.data
    },

    async migrate(targetOwnerEmail: string, sourceOwnerEmail: string): Promise<MigrationResult> {
        const res = await axios.post<{ success: boolean; data: MigrationResult }>('/gluon/organizations/migrate', {
            targetOwnerEmail,
            sourceOwnerEmail,
        })
        return res.data.data
    },

    async toggleMultiMc(ownerEmail: string, enabled: boolean): Promise<{ multiMcEnabled: boolean; organizationId: string }> {
        const res = await axios.post<{ success: boolean; data: { multiMcEnabled: boolean; organizationId: string } }>('/gluon/organizations/toggle-multi-mc', {
            ownerEmail,
            enabled,
        })
        return res.data.data
    },
}
